// extracted by mini-css-extract-plugin
export default {"wrapper":"KW1kSrolPgGpZBDt2St0","counter":"sx0gPYFtcQK2I6TXTLwv"};